import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from '../../../Components/forms/loginform/LoginForm';
import { loginApi } from '../../../api/authApi';
import { clearStoredAuth } from '../../admin/auth/authStorage';
import { canAccessAdminDashboard } from '../../admin/auth/rbac';
import signupImage from '../../../assets/images/signup.jpg';
import logo from '../../../assets/images/logo.png';
import './login.css';

/**
 * Resolve the post-login route from the user's role rather than a fixed
 * user_type_id map — the IDs in user_type_master are not fixed, so any
 * admin-capable role (Super User, Hospital Admin, Doctor) must land on the
 * admin dashboard where RBAC picks the correct portal UI.
 */
const resolveDashboardRoute = (user) =>
  canAccessAdminDashboard(user) ? '/admin/dashboard' : '/';

export const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async ({ mobile_no, password, remember }) => {
    setError('');
    setLoading(true);
    try {
      const { token, user } = await loginApi({ mobile_no, password });

      clearStoredAuth();
      const storage = remember ? localStorage : sessionStorage;
      storage.setItem('token', token);
      storage.setItem('user', JSON.stringify(user));

      // Navigate based on role
      navigate(resolveDashboardRoute(user), { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container fluid className="h-100 p-0">
        <Row className="login-row g-0">
          {/* Left — image panel */}
          <Col xs={12} md={6} className="login-image-col d-none d-md-block">
            <img
              src={signupImage}
              alt="Medical professionals"
              className="login-side-image"
            />
          </Col>

          {/* Right — form panel */}
          <Col xs={12} md={6} className="login-form-col">
            <div className="login-form-container">
              <img src={logo} alt="Bizaario Care" className="login-logo" />
              <LoginForm onSubmit={handleLogin} loading={loading} error={error} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
